import { styled } from "@mui/material";
import { NavLink } from "react-router-dom";

export const Styled = {
    Container: styled("div")`
        align-items: center;
        display: flex;
        justify-content: space-between;
        height: 56px;
        padding: 16px 32px;
        background-color: ${props => props.theme.palette.secondary.main};

        & .MuiBreadcrumbs-separator {
            display: none;
        }

        ${props => props.theme.breakpoints.down("sm")} {
            padding: 16px 10px;
            gap: 15px;

            & .MuiButtonBase-root {
                padding: 4px 7px 3px 8px;
            }
        }
    `,
    NavLink: styled(NavLink)`
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #929292;
        font-family: Figtree;
        font-weight: 400;
        line-height: 140%;
        transition: color 0.2s linear;

        &:hover {
            color: ${props => props.theme.palette.primary.main};
        }

        &.active {
            color: #f9f9f9;
        }

        ${props => props.theme.breakpoints.down("sm")} {
            font-size: 12px;
        }
    `,
    Button: styled("div")`
        cursor: pointer;
        background-color: ${props => props.theme.palette.primary.main};
        transition: background-color 0.2s ease-in-out;
        &:hover {
            background-color: ${props => props.theme.palette.primary.dark};
        }
        margin-right: 10px;
        height: 38px;
        width: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 32px;

        ${props => props.theme.breakpoints.down("sm")} {
            height: 30px;
            width: 30px;

            & svg {
                width: 18px;
            }
        }
    `,
};
